import React, { useMemo } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import moment from "moment";

import IconSvgComponent from "components/common/IconSvgComponent";
import {
  AssessmentContainer,
  AssessmentWrapper,
  AssessmentIcon,
  AssessmentTitle,
  AssessmentStats,
  AssessmentStat,
  AssessmentButton,
} from "styles/components/SelectAssessment";
import { selectAssessmentSeries } from "store/state/assessment/actions";
import stemifyRoutes from "constants/routes";

const Assessment = ({
  icon,
  id,
  deploymentId,
  title,
  attemptsRemaining,
  timeLimit,
  prevScore,
  coolingPeriod,
  lastAttemptDate,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const takeAssessment = async () => {
    await dispatch(selectAssessmentSeries({ assessmentId: id, deploymentId }));

    history.push({
      pathname: `${stemifyRoutes.assessments}/${deploymentId}/${id}`,
      state: { referrer: `${stemifyRoutes.assessments}` },
    });
  };

  const hasCooledDown = useMemo(() => {
    return (
      !lastAttemptDate ||
      moment(lastAttemptDate)
        .add(coolingPeriod, "days")
        .isSameOrBefore(moment(), "day")
    );
  }, [lastAttemptDate, coolingPeriod]);

  const canTakeAssessment = useMemo(() => {
    return attemptsRemaining > 0 && hasCooledDown;
  }, [hasCooledDown, attemptsRemaining]);

  return (
    <AssessmentContainer>
      <AssessmentWrapper>
        <AssessmentIcon className="assessment__icon">
          <IconSvgComponent iconPath={icon} />
        </AssessmentIcon>

        <AssessmentTitle>{title}</AssessmentTitle>

        <AssessmentStats>
          <AssessmentStat>Attempts Remaining: {attemptsRemaining}</AssessmentStat>
          <AssessmentStat>Time Limit: {timeLimit}</AssessmentStat>
          <AssessmentStat>Previous Score: {prevScore}</AssessmentStat>
        </AssessmentStats>

        {canTakeAssessment ? (
          <AssessmentButton className="assessment__button" tabIndex={0} onClick={takeAssessment}>
            Take Assessment
          </AssessmentButton>
        ) : (
          <div
            style={{
              backgroundColor: "#5965ff",
              borderRadius: "8px",
              color: "#ffffff",
              width: "fit-content",
              margin: "0 auto",
              padding: "4px 24px",
            }}
          >
            {attemptsRemaining <= 0 ? "No attempts remaining" : "Cooling down"}
          </div>
        )}
      </AssessmentWrapper>
    </AssessmentContainer>
  );
};

export default Assessment;
